import React from "react";
import './Footer.css';
import footerlogo from '../../Images/footer-logo.svg';
import fbIcon from '../../Images/facebook icon.svg';
import igIcon from '../../Images/instagram icon.svg';
import liIcon from '../../Images/linkedin icon.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import standingline from '../../Images/footer-standing-line.svg';

const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleFooterProductClick = (e) => {
        e.preventDefault();
        navigate('/products');
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
    };

    const handleScroll = (e, id) => {
        e.preventDefault();

        if (location.pathname === '/') {
            navigate('/', { state: { targetSection: id }, replace: true });
        } else {
            navigate('/', { state: { targetSection: id } });
        }
    };

    return (
        <>
            <section className="footer-top" id='footer'>
                <div className="contact-info">
                    <p className="contact-title">Contact Info</p>
                    <h3 className="contact-subtext">We are always happy to assist you</h3>
                    <p className="assistance-hours">Assistance hours:<br />Monday - Friday 6 am to 8 pm</p>
                </div>
                <div className="contact-details-container">
                    <div className="contact-details">
                        <p className="label">Address</p>
                        <hr className="underline" />
                        <p className="label-details">Meydan Grandstand, 6th Floor,Meydan Road<br />Nad Al Sheba, Dubai, UAE</p>
                    </div>
                    <div className="contact-details">
                        <p className="label">Email Address</p>
                        <hr className="underline" />
                        <a
                            href="https://mail.google.com/mail/?view=cm&fs=1&to=projects@stockportsolutions.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="label-details"
                        >
                            projects@stockportsolutions.com
                        </a>
                        {/* <p className="label-highlight">stockportsolutions@gmail.com</p> */}
                    </div>
                    <div className="contact-details">
                        <p className="label">Number</p>
                        <hr className="underline" />
                        <p className="label-details">
                            <a href="tel:+971557841533" style={{ textDecoration: 'none', color: 'inherit' }}>
                                +971 55 784 1533
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            <div className="footer-middle">
                <div className="footer-middle-logo-row">
                    <div className="footer-middle-logo">
                        <img src={footerlogo} alt="stockportlogo" className="footer-logo" />
                    </div>
                </div>
                <p className="footer-text">provides high-quality products with exceptional service, delivering reliable <br /> solutions to meet all your needs.</p>
                <div className="footer-middle-underline"></div>
                <ul className="footer-nav">
                    <li><a className='footer-nav-items' href="#home" onClick={(e) => handleScroll(e, 'home')}>Home</a></li>
                    <li><a className='footer-nav-items' href="/products" onClick={handleFooterProductClick}>Product</a></li>
                    <li><a className='footer-nav-items' href="#aboutus" onClick={(e) => handleScroll(e, 'aboutus')}>About Us</a></li>
                    <li><a className='footer-nav-items' href="#happycustomer" onClick={(e) => handleScroll(e, 'happycustomer')}>Testimonial</a></li>
                    <li><a className='footer-nav-items' href="#faqs" onClick={(e) => handleScroll(e, 'faqs')}>FAQs</a></li>
                </ul>
            </div>

            <div className="footer-bottom-container">
                <div className="footer-social-icons">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                        <img src={fbIcon} alt="Facebook" className="footer-social-images" />
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                        <img src={igIcon} alt="Instagram" className="footer-social-images" />
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                        <img src={liIcon} alt="LinkedIn" className="footer-social-images" />
                    </a>
                </div>
                <div className="footer-right">
                    <p className="copyright">
                        © 2025 Techlambdas Pvt Ltd All rights reserved.
                    </p>
                </div>
            </div>
        </>
    )
}

export default Footer;